<mat-form-field appearance="fill">
  <mat-label *ngIf="label!=undefined?label:'Select ULB'">{{label}} </mat-label>
  <input matInput placeholder="Search ULB" [formControl]="name" [matAutocomplete]="ulbSelect">
  <mat-autocomplete #ulbSelect="matAutocomplete">
    <mat-option *ngIf="isLoading" class="is-loading">Loading...</mat-option>
    <ng-container *ngIf="!isLoading">
      <mat-option *ngFor="let item of options" [value]="item.name">
        <b>{{item.name}}</b> | {{item.districtName}}
      </mat-option>
    </ng-container>
  </mat-autocomplete>
  <mat-hint *ngIf="!name.value&& !options.length"> Please enter atleast 3 characters. </mat-hint>
  <mat-error *ngIf="name.hasError('required')">
    This field is required.
  </mat-error>
  <mat-error *ngIf="name.hasError('requireMatch')">
    Please select from the options provided.
  </mat-error>
</mat-form-field>